import type { Drama } from '@/types/content';

export const dramas: Drama[] = [
  {
    id: 'long-night',
    title: '长夜将明',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20drama%20key%20art%20of%20a%20lone%20detective%20in%20a%20rain%20soaked%20neon%20alley%20at%20midnight%2C%20moody%20atmospheric%20lighting%2C%20rich%20film%20color%20grading%2C%20subtle%20film%20grain%2C%20elegant%20editorial%20poster%20composition%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=cover-01&orientation=portrait',
    banner:
      'https://readdy.ai/api/search-image?query=cinematic%20wide%20key%20art%20of%20a%20rainy%20city%20skyline%20at%20night%20with%20glowing%20street%20lights%20and%20a%20silhouette%20figure%2C%20moody%20atmospheric%20lighting%2C%20rich%20film%20color%20grading%2C%20subtle%20film%20grain%2C%20epic%20editorial%20composition%2C%20high%20detail%2C%20no%20text&width=1600&height=900&seq=banner-01&orientation=landscape',
    synopsis:
      '刑警顾南川在调查一桩跨越十二年的连环悬案时，发现所有线索都指向自己童年失忆的那个雨夜。随着真相层层剥开，他不得不在正义与亲情之间做出抉择。',
    genres: ['悬疑剧', '都市剧'],
    year: 2024,
    decade: '2020年代',
    region: '中国大陆',
    rating: 8.9,
    heat: 98,
    updateTime: '2026-10-15',
    status: '更新至18集',
    episodeCount: 24,
    director: '陈砚舟',
    actors: ['顾南川', '沈知意', '韩景行', '叶闻笛'],
    tags: ['高口碑', '反转神剧', '双强对峙'],
    featured: true,
    cast: [
      {
        id: 'ln-1',
        name: '顾南川',
        actor: '顾南川',
        avatar:
          'https://readdy.ai/api/search-image?query=cinematic%20character%20portrait%20of%20a%20serious%20young%20male%20detective%20in%20a%20dark%20coat%2C%20moody%20studio%20lighting%2C%20deep%20blue%20background%2C%20subtle%20film%20grain%2C%20consistent%20drama%20style%2C%20high%20detail%2C%20no%20text&width=400&height=400&seq=cast-01-1&orientation=squarish',
        role: '市局刑侦支队队长，外冷内热，背负着十二年前的秘密。',
        intro: '办案冷静缜密，却始终无法直面自己的过去，是全剧最核心的情感支点。',
      },
      {
        id: 'ln-2',
        name: '沈知意',
        actor: '沈知意',
        avatar:
          'https://readdy.ai/api/search-image?query=cinematic%20character%20portrait%20of%20an%20elegant%20female%20forensic%20doctor%20with%20short%20hair%2C%20moody%20studio%20lighting%2C%20deep%20blue%20background%2C%20subtle%20film%20grain%2C%20consistent%20drama%20style%2C%20high%20detail%2C%20no%20text&width=400&height=400&seq=cast-01-2&orientation=squarish',
        role: '法医，理性克制，是唯一敢当面质疑顾南川判断的人。',
        intro: '用一把解剖刀切开谎言，也在不知不觉中靠近了真相与危险。',
      },
      {
        id: 'ln-3',
        name: '韩景行',
        actor: '韩景行',
        avatar:
          'https://readdy.ai/api/search-image?query=cinematic%20character%20portrait%20of%20a%20mysterious%20businessman%20in%20a%20tailored%20suit%2C%20moody%20studio%20lighting%2C%20deep%20blue%20background%2C%20subtle%20film%20grain%2C%20consistent%20drama%20style%2C%20high%20detail%2C%20no%20text&width=400&height=400&seq=cast-01-3&orientation=squarish',
        role: '地产集团继承人，温和外表下藏着精密的算计。',
        intro: '亦正亦邪的关键人物，其真实立场直到最终章才被揭开。',
      },
      {
        id: 'ln-4',
        name: '叶闻笛',
        actor: '叶闻笛',
        avatar:
          'https://readdy.ai/api/search-image?query=cinematic%20character%20portrait%20of%20a%20determined%20female%20journalist%20with%20a%20notebook%2C%20moody%20studio%20lighting%2C%20deep%20blue%20background%2C%20subtle%20film%20grain%2C%20consistent%20drama%20style%2C%20high%20detail%2C%20no%20text&width=400&height=400&seq=cast-01-4&orientation=squarish',
        role: '调查记者，为追查旧案不惜以身犯险。',
        intro: '用笔尖撕开沉默，是推动剧情揭开黑幕的重要力量。',
      },
    ],
  },
  {
    id: 'wind-changan',
    title: '风起长安',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20period%20drama%20key%20art%20of%20an%20ancient%20chinese%20warrior%20holding%20a%20sword%20before%20a%20grand%20city%20gate%2C%20dramatic%20sunset%20lighting%2C%20rich%20film%20color%20grading%2C%20subtle%20film%20grain%2C%20elegant%20editorial%20poster%20composition%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=cover-02&orientation=portrait',
    banner:
      'https://readdy.ai/api/search-image?query=cinematic%20wide%20key%20art%20of%20a%20vast%20ancient%20chinese%20imperial%20city%20under%20a%20dramatic%20golden%20sky%2C%20moody%20atmospheric%20lighting%2C%20rich%20film%20color%20grading%2C%20subtle%20film%20grain%2C%20epic%20editorial%20composition%2C%20high%20detail%2C%20no%20text&width=1600&height=900&seq=banner-02&orientation=landscape',
    synopsis:
      '少年将军萧承稷临危受命，携一纸密诏入长安。朝堂暗流与边关烽火交织，他必须在天亮之前找出通敌的内鬼，才能守住这座他誓死守护的城。',
    genres: ['古装剧', '历史剧'],
    year: 2023,
    decade: '2020年代',
    region: '中国大陆',
    rating: 8.6,
    heat: 94,
    updateTime: '2026-10-12',
    status: '全36集',
    episodeCount: 36,
    director: '陆怀山',
    actors: ['萧承稷', '苏令仪', '裴无咎', '姜知微'],
    tags: ['大制作', '权谋群像', '名场面多'],
    featured: true,
    cast: [
      {
        id: 'wc-1',
        name: '萧承稷',
        actor: '萧承稷',
        avatar:
          'https://readdy.ai/api/search-image?query=cinematic%20character%20portrait%20of%20a%20young%20ancient%20chinese%20general%20in%20ornate%20armor%2C%20warm%20studio%20lighting%2C%20deep%20teal%20background%2C%20subtle%20film%20grain%2C%20consistent%20drama%20style%2C%20high%20detail%2C%20no%20text&width=400&height=400&seq=cast-02-1&orientation=squarish',
        role: '镇北军少将军，忠勇果决，却屡遭朝堂猜忌。',
        intro: '一身戎马只为家国，是贯穿全剧的少年英雄形象。',
      },
      {
        id: 'wc-2',
        name: '苏令仪',
        actor: '苏令仪',
        avatar:
          'https://readdy.ai/api/search-image?query=cinematic%20character%20portrait%20of%20an%20elegant%20ancient%20chinese%20noble%20lady%20in%20silk%20hanfu%2C%20warm%20studio%20lighting%2C%20deep%20teal%20background%2C%20subtle%20film%20grain%2C%20consistent%20drama%20style%2C%20high%20detail%2C%20no%20text&width=400&height=400&seq=cast-02-2&orientation=squarish',
        role: '太常寺卿之女，聪慧通透，深谙朝堂规矩。',
        intro: '在深闺与权谋之间游走，是萧承稷最信赖的盟友。',
      },
      {
        id: 'wc-3',
        name: '裴无咎',
        actor: '裴无咎',
        avatar:
          'https://readdy.ai/api/search-image?query=cinematic%20character%20portrait%20of%20a%20calm%20ancient%20chinese%20strategist%20scholar%20with%20a%20fan%2C%20warm%20studio%20lighting%2C%20deep%20teal%20background%2C%20subtle%20film%20grain%2C%20consistent%20drama%20style%2C%20high%20detail%2C%20no%20text&width=400&height=400&seq=cast-02-3&orientation=squarish',
        role: '幕僚军师，算无遗策，心怀更宏大的天下棋局。',
        intro: '表面淡然，实则每一步都在为乱世落子。',
      },
      {
        id: 'wc-4',
        name: '姜知微',
        actor: '姜知微',
        avatar:
          'https://readdy.ai/api/search-image?query=cinematic%20character%20portrait%20of%20a%20sharp%20ancient%20chinese%20female%20spy%20in%20dark%20robes%2C%20warm%20studio%20lighting%2C%20deep%20teal%20background%2C%20subtle%20film%20grain%2C%20consistent%20drama%20style%2C%20high%20detail%2C%20no%20text&width=400&height=400&seq=cast-02-4&orientation=squarish',
        role: '暗卫出身的密探，身世成谜，游走于各方势力之间。',
        intro: '她的每一次选择，都在暗中改写着长安的走向。',
      },
    ],
  },
  {
    id: 'star-era',
    title: '星海纪元',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20sci%20fi%20drama%20key%20art%20of%20an%20astronaut%20floating%20before%20a%20glowing%20planet%2C%20deep%20space%20lighting%2C%20rich%20film%20color%20grading%2C%20subtle%20film%20grain%2C%20elegant%20editorial%20poster%20composition%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=cover-03&orientation=portrait',
    banner:
      'https://readdy.ai/api/search-image?query=cinematic%20wide%20key%20art%20of%20a%20spaceship%20approaching%20a%20ringed%20planet%20in%20deep%20space%2C%20dramatic%20cosmic%20lighting%2C%20rich%20film%20color%20grading%2C%20subtle%20film%20grain%2C%20epic%20editorial%20composition%2C%20high%20detail%2C%20no%20text&width=1600&height=900&seq=banner-03&orientation=landscape',
    synopsis:
      '地球资源枯竭的百年后，飞船"回声号"承载着最后的希望驶向深空。当船员们陆续收到来自未来的求救信号，他们才发现这场远航本身就是一场精心设计的试验。',
    genres: ['科幻剧', '悬疑剧'],
    year: 2025,
    decade: '2020年代',
    region: '中国大陆',
    rating: 8.4,
    heat: 90,
    updateTime: '2026-10-10',
    status: '更新至12集',
    episodeCount: 20,
    director: '林知远',
    actors: ['陆时衍', '温以宁', '程屿', '许清和'],
    tags: ['硬核科幻', '视效炸裂', '烧脑'],
    featured: true,
    cast: [
      {
        id: 'se-1',
        name: '陆时衍',
        actor: '陆时衍',
        avatar:
          'https://readdy.ai/api/search-image?query=cinematic%20character%20portrait%20of%20a%20calm%20male%20astronaut%20commander%20in%20a%20futuristic%20suit%2C%20cool%20studio%20lighting%2C%20dark%20indigo%20background%2C%20subtle%20film%20grain%2C%20consistent%20drama%20style%2C%20high%20detail%2C%20no%20text&width=400&height=400&seq=cast-03-1&orientation=squarish',
        role: '"回声号"船长，理性到近乎冷酷的决策者。',
        intro: '他必须在全船生死与个人信念之间反复权衡。',
      },
      {
        id: 'se-2',
        name: '温以宁',
        actor: '温以宁',
        avatar:
          'https://readdy.ai/api/search-image?query=cinematic%20character%20portrait%20of%20a%20brilliant%20female%20scientist%20in%20a%20space%20station%20lab%2C%20cool%20studio%20lighting%2C%20dark%20indigo%20background%2C%20subtle%20film%20grain%2C%20consistent%20drama%20style%2C%20high%20detail%2C%20no%20text&width=400&height=400&seq=cast-03-2&orientation=squarish',
        role: '首席科学家，最先察觉信号异常的人。',
        intro: '她的坚持让全船避免了第一次灾难，也带来了更大的谜团。',
      },
      {
        id: 'se-3',
        name: '程屿',
        actor: '程屿',
        avatar:
          'https://readdy.ai/api/search-image?query=cinematic%20character%20portrait%20of%20a%20young%20male%20engineer%20with%20goggles%20in%20a%20machine%20room%2C%20cool%20studio%20lighting%2C%20dark%20indigo%20background%2C%20subtle%20film%20grain%2C%20consistent%20drama%20style%2C%20high%20detail%2C%20no%20text&width=400&height=400&seq=cast-03-3&orientation=squarish',
        role: '飞船机械师，乐观话痨，却是最可靠的后盾。',
        intro: '用一次次极限抢修，替所有人守住生的希望。',
      },
      {
        id: 'se-4',
        name: '许清和',
        actor: '许清和',
        avatar:
          'https://readdy.ai/api/search-image?query=cinematic%20character%20portrait%20of%20a%20mysterious%20female%20navigator%20with%20a%20headset%2C%20cool%20studio%20lighting%2C%20dark%20indigo%20background%2C%20subtle%20film%20grain%2C%20consistent%20drama%20style%2C%20high%20detail%2C%20no%20text&width=400&height=400&seq=cast-03-4&orientation=squarish',
        role: '领航员，掌握着全船航向，也隐瞒着一个秘密。',
        intro: '她与那串求救信号之间，似乎有着不寻常的联系。',
      },
    ],
  },
  {
    id: 'mist-manhunt',
    title: '迷雾追凶',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20thriller%20drama%20key%20art%20of%20a%20detective%20flashlight%20cutting%20through%20thick%20fog%20at%20night%2C%20moody%20atmospheric%20lighting%2C%20rich%20film%20color%20grading%2C%20subtle%20film%20grain%2C%20elegant%20editorial%20poster%20composition%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=cover-04&orientation=portrait',
    banner:
      'https://readdy.ai/api/search-image?query=cinematic%20wide%20key%20art%20of%20a%20foggy%20forest%20road%20with%20police%20car%20lights%20at%20night%2C%20moody%20atmospheric%20lighting%2C%20rich%20film%20color%20grading%2C%20subtle%20film%20grain%2C%20epic%20editorial%20composition%2C%20high%20detail%2C%20no%20text&width=1600&height=900&seq=banner-04&orientation=landscape',
    synopsis:
      '小镇接连发生失踪案，退休法医裴云天被重新请回现场。他凭借一枚被人忽略的纽扣，牵出二十年前那场被草草结案的旧案，也让整个小镇的秘密浮出水面。',
    genres: ['悬疑剧', '都市剧'],
    year: 2024,
    decade: '2020年代',
    region: '中国大陆',
    rating: 8.2,
    heat: 86,
    updateTime: '2026-10-08',
    status: '全28集',
    episodeCount: 28,
    director: '方牧之',
    actors: ['裴云天', '谢鹤鸣', '秦书宁', '周砚'],
    tags: ['本格推理', '老戏骨', '后劲十足'],
    featured: true,
    cast: [
      {
        id: 'mm-1',
        name: '裴云天',
        actor: '裴云天',
        avatar:
          'https://readdy.ai/api/search-image?query=cinematic%20character%20portrait%20of%20an%20older%20male%20forensic%20expert%20with%20grey%20hair%20and%20glasses%2C%20moody%20studio%20lighting%2C%20smoky%20grey%20background%2C%20subtle%20film%20grain%2C%20consistent%20drama%20style%2C%20high%20detail%2C%20no%20text&width=400&height=400&seq=cast-04-1&orientation=squarish',
        role: '退休法医，观察入微，被旧案重新拉回一线。',
        intro: '沉默寡言却心思缜密，是全剧的推理核心。',
      },
      {
        id: 'mm-2',
        name: '谢鹤鸣',
        actor: '谢鹤鸣',
        avatar:
          'https://readdy.ai/api/search-image?query=cinematic%20character%20portrait%20of%20a%20young%20police%20officer%20in%20uniform%2C%20moody%20studio%20lighting%2C%20smoky%20grey%20background%2C%20subtle%20film%20grain%2C%20consistent%20drama%20style%2C%20high%20detail%2C%20no%20text&width=400&height=400&seq=cast-04-2&orientation=squarish',
        role: '年轻刑警，热血直率，与裴云天组成师徒搭档。',
        intro: '从不服气到真心敬佩，他的成长线同样动人。',
      },
      {
        id: 'mm-3',
        name: '秦书宁',
        actor: '秦书宁',
        avatar:
          'https://readdy.ai/api/search-image?query=cinematic%20character%20portrait%20of%20a%20female%20town%20doctor%20with%20a%20gentle%20expression%2C%20moody%20studio%20lighting%2C%20smoky%20grey%20background%2C%20subtle%20film%20grain%2C%20consistent%20drama%20style%2C%20high%20detail%2C%20no%20text&width=400&height=400&seq=cast-04-3&orientation=squarish',
        role: '小镇医生，看似温和，与旧案有着隐秘关联。',
        intro: '她的证词成为解开谜题的关键一环。',
      },
      {
        id: 'mm-4',
        name: '周砚',
        actor: '周砚',
        avatar:
          'https://readdy.ai/api/search-image?query=cinematic%20character%20portrait%20of%20a%20stoic%20middle%20aged%20man%20in%20a%20dark%20jacket%2C%20moody%20studio%20lighting%2C%20smoky%20grey%20background%2C%20subtle%20film%20grain%2C%20consistent%20drama%20style%2C%20high%20detail%2C%20no%20text&width=400&height=400&seq=cast-04-4&orientation=squarish',
        role: '镇上旅馆老板，沉默寡言，知道得比说出口的多。',
        intro: '一个眼神就藏着半部剧的信息量。',
      },
    ],
  },
  {
    id: 'city-drifter',
    title: '都市浮生记',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20urban%20drama%20key%20art%20of%20a%20young%20professional%20standing%20on%20a%20rooftop%20at%20dusk%20overlooking%20a%20city%2C%20warm%20dusk%20lighting%2C%20rich%20film%20color%20grading%2C%20subtle%20film%20grain%2C%20elegant%20editorial%20poster%20composition%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=cover-05&orientation=portrait',
    banner:
      'https://readdy.ai/api/search-image?query=cinematic%20wide%20key%20art%20of%20a%20glowing%20modern%20city%20at%20dusk%20seen%20from%20a%20rooftop%2C%20warm%20atmospheric%20lighting%2C%20rich%20film%20color%20grading%2C%20subtle%20film%20grain%2C%20epic%20editorial%20composition%2C%20high%20detail%2C%20no%20text&width=1600&height=900&seq=banner-05&orientation=landscape',
    synopsis:
      '三个合租在老旧小区的年轻人，在房租、加班与梦想之间反复拉扯。当生活一次次把他们推倒，他们决定用自己的方式，在这座城市里活出体面的样子。',
    genres: ['都市剧', '现代剧'],
    year: 2025,
    decade: '2020年代',
    region: '中国大陆',
    rating: 8.0,
    heat: 83,
    updateTime: '2026-10-05',
    status: '更新至22集',
    episodeCount: 30,
    director: '苏凌晨',
    actors: ['江砚白', '夏知遥', '孟星野', '钟以棠'],
    tags: ['现实主义', '扎心共鸣', '群像'],
    featured: true,
    cast: [
      {
        id: 'cd-1',
        name: '江砚白',
        actor: '江砚白',
        avatar:
          'https://readdy.ai/api/search-image?query=cinematic%20character%20portrait%20of%20a%20tired%20young%20office%20worker%20in%20a%20shirt%2C%20warm%20studio%20lighting%2C%20muted%20amber%20background%2C%20subtle%20film%20grain%2C%20consistent%20drama%20style%2C%20high%20detail%2C%20no%20text&width=400&height=400&seq=cast-05-1&orientation=squarish',
        role: '产品经理，表面体面，背地里被业绩压得喘不过气。',
        intro: '他的经历几乎是当代职场人的真实写照。',
      },
      {
        id: 'cd-2',
        name: '夏知遥',
        actor: '夏知遥',
        avatar:
          'https://readdy.ai/api/search-image?query=cinematic%20character%20portrait%20of%20a%20cheerful%20young%20female%20illustrator%20with%20a%20pencil%2C%20warm%20studio%20lighting%2C%20muted%20amber%20background%2C%20subtle%20film%20grain%2C%20consistent%20drama%20style%2C%20high%20detail%2C%20no%20text&width=400&height=400&seq=cast-05-2&orientation=squarish',
        role: '自由插画师，收入不稳却始终乐观。',
        intro: '她教会合租的三个人如何在窘迫里保留浪漫。',
      },
      {
        id: 'cd-3',
        name: '孟星野',
        actor: '孟星野',
        avatar:
          'https://readdy.ai/api/search-image?query=cinematic%20character%20portrait%20of%20a%20laid%20back%20young%20male%20musician%20with%20headphones%2C%20warm%20studio%20lighting%2C%20muted%20amber%20background%2C%20subtle%20film%20grain%2C%20consistent%20drama%20style%2C%20high%20detail%2C%20no%20text&width=400&height=400&seq=cast-05-3&orientation=squarish',
        role: '地下乐队主唱，白天送外卖，晚上追梦。',
        intro: '用最洒脱的姿态，扛着最沉重的现实。',
      },
      {
        id: 'cd-4',
        name: '钟以棠',
        actor: '钟以棠',
        avatar:
          'https://readdy.ai/api/search-image?query=cinematic%20character%20portrait%20of%20a%20confident%20young%20businesswoman%20in%20a%20blazer%2C%20warm%20studio%20lighting%2C%20muted%20amber%20background%2C%20subtle%20film%20grain%2C%20consistent%20drama%20style%2C%20high%20detail%2C%20no%20text&width=400&height=400&seq=cast-05-4&orientation=squarish',
        role: '创业公司创始人，野心勃勃又格外仗义。',
        intro: '她的出现，让三个人的命运出现新的转机。',
      },
    ],
  },
  {
    id: 'mountain-mystery',
    title: '山海谜踪',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20adventure%20drama%20key%20art%20of%20an%20expedition%20figure%20facing%20giant%20misty%20mountains%2C%20moody%20atmospheric%20lighting%2C%20rich%20film%20color%20grading%2C%20subtle%20film%20grain%2C%20elegant%20editorial%20poster%20composition%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=cover-06&orientation=portrait',
    banner:
      'https://readdy.ai/api/search-image?query=cinematic%20wide%20key%20art%20of%20misty%20ancient%20mountains%20with%20a%20tiny%20caravan%20of%20explorers%2C%20atmospheric%20lighting%2C%20rich%20film%20color%20grading%2C%20subtle%20film%20grain%2C%20epic%20editorial%20composition%2C%20high%20detail%2C%20no%20text&width=1600&height=900&seq=banner-06&orientation=landscape',
    synopsis:
      '考古队深入西南无人区，寻找传说中消失的古国遗址。当向导一次次指向地图上没有的地方，队员们才意识到，真正需要提防的或许不是荒野，而是彼此。',
    genres: ['悬疑剧', '古装剧'],
    year: 2023,
    decade: '2020年代',
    region: '中国大陆',
    rating: 7.9,
    heat: 78,
    updateTime: '2026-09-28',
    status: '全24集',
    episodeCount: 24,
    director: '野村谦',
    actors: ['段祺临', '白清晏', '岑仲', '苏黎'],
    tags: ['探险', '异域风光', '悬念密集'],
    featured: false,
    cast: [
      {
        id: 'ma-1',
        name: '段祺临',
        actor: '段祺临',
        avatar:
          'https://readdy.ai/api/search-image?query=cinematic%20character%20portrait%20of%20a%20rugged%20male%20archaeologist%20in%20an%20explorer%20jacket%2C%20earthy%20studio%20lighting%2C%20moss%20green%20background%2C%20subtle%20film%20grain%2C%20consistent%20drama%20style%2C%20high%20detail%2C%20no%20text&width=400&height=400&seq=cast-06-1&orientation=squarish',
        role: '考古队领队，执着于古国传说，也背负着执念。',
        intro: '他寻找的也许不只是一座遗址，而是一个答案。',
      },
      {
        id: 'ma-2',
        name: '白清晏',
        actor: '白清晏',
        avatar:
          'https://readdy.ai/api/search-image?query=cinematic%20character%20portrait%20of%20a%20focused%20female%20historian%20with%20a%20field%20notebook%2C%20earthy%20studio%20lighting%2C%20moss%20green%20background%2C%20subtle%20film%20grain%2C%20consistent%20drama%20style%2C%20high%20detail%2C%20no%20text&width=400&height=400&seq=cast-06-2&orientation=squarish',
        role: '历史学者，掌握着破解古文字的钥匙。',
        intro: '冷静的判断多次把队伍从危险中拉回来。',
      },
      {
        id: 'ma-3',
        name: '岑仲',
        actor: '岑仲',
        avatar:
          'https://readdy.ai/api/search-image?query=cinematic%20character%20portrait%20of%20a%20quiet%20local%20mountain%20guide%2C%20earthy%20studio%20lighting%2C%20moss%20green%20background%2C%20subtle%20film%20grain%2C%20consistent%20drama%20style%2C%20high%20detail%2C%20no%20text&width=400&height=400&seq=cast-06-3&orientation=squarish',
        role: '本地向导，熟悉山林，却对某些路线讳莫如深。',
        intro: '他知道的秘密，足以改变整支队伍的命运。',
      },
      {
        id: 'ma-4',
        name: '苏黎',
        actor: '苏黎',
        avatar:
          'https://readdy.ai/api/search-image?query=cinematic%20character%20portrait%20of%20a%20determined%20young%20female%20photographer%20with%20a%20camera%2C%20earthy%20studio%20lighting%2C%20moss%20green%20background%2C%20subtle%20film%20grain%2C%20consistent%20drama%20style%2C%20high%20detail%2C%20no%20text&width=400&height=400&seq=cast-06-4&orientation=squarish',
        role: '随队摄影师，用镜头记录真相，也捕捉到了不该拍到的东西。',
        intro: '她的相机里，藏着解开谜团的关键影像。',
      },
    ],
  },
  {
    id: 'spring-confession',
    title: '春日告白',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20romance%20drama%20key%20art%20of%20a%20young%20couple%20under%20blooming%20cherry%20blossoms%2C%20soft%20pastel%20lighting%2C%20rich%20film%20color%20grading%2C%20subtle%20film%20grain%2C%20elegant%20editorial%20poster%20composition%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=cover-07&orientation=portrait',
    banner:
      'https://readdy.ai/api/search-image?query=cinematic%20wide%20key%20art%20of%20a%20blossoming%20spring%20park%20path%20with%20soft%20petals%20falling%2C%20dreamy%20pastel%20lighting%2C%20rich%20film%20color%20grading%2C%20subtle%20film%20grain%2C%20epic%20editorial%20composition%2C%20high%20detail%2C%20no%20text&width=1600&height=900&seq=banner-07&orientation=landscape',
    synopsis:
      '高中时代的暗恋对象，八年后成了她的直属上司。曾经没能说出口的那句话，在一次次加班、出差与争吵之后，终于有了重新开口的勇气。',
    genres: ['言情剧', '都市剧'],
    year: 2025,
    decade: '2020年代',
    region: '中国大陆',
    rating: 7.8,
    heat: 80,
    updateTime: '2026-10-03',
    status: '全20集',
    episodeCount: 20,
    director: '温子卿',
    actors: ['宋亦寒', '林晚意', '傅司南', '黎昭'],
    tags: ['甜宠', '双向奔赴', '治愈'],
    featured: false,
    cast: [
      {
        id: 'sc-1',
        name: '宋亦寒',
        actor: '宋亦寒',
        avatar:
          'https://readdy.ai/api/search-image?query=cinematic%20character%20portrait%20of%20a%20handsome%20young%20male%20executive%20with%20a%20gentle%20smile%2C%20soft%20studio%20lighting%2C%20blush%20pink%20background%2C%20subtle%20film%20grain%2C%20consistent%20drama%20style%2C%20high%20detail%2C%20no%20text&width=400&height=400&seq=cast-07-1&orientation=squarish',
        role: '冷静自律的部门总监，唯独对她格外纵容。',
        intro: '八年的等待，让他把喜欢藏成了习惯。',
      },
      {
        id: 'sc-2',
        name: '林晚意',
        actor: '林晚意',
        avatar:
          'https://readdy.ai/api/search-image?query=cinematic%20character%20portrait%20of%20a%20cheerful%20young%20female%20designer%20with%20a%20sketchbook%2C%20soft%20studio%20lighting%2C%20blush%20pink%20background%2C%20subtle%20film%20grain%2C%20consistent%20drama%20style%2C%20high%20detail%2C%20no%20text&width=400&height=400&seq=cast-07-2&orientation=squarish',
        role: '新人设计师，嘴硬心软，藏着少年时的心动。',
        intro: '她的成长与勇敢，是这部剧最让人心动的地方。',
      },
      {
        id: 'sc-3',
        name: '傅司南',
        actor: '傅司南',
        avatar:
          'https://readdy.ai/api/search-image?query=cinematic%20character%20portrait%20of%20a%20playful%20young%20male%20colleague%20in%20a%20casual%20sweater%2C%20soft%20studio%20lighting%2C%20blush%20pink%20background%2C%20subtle%20film%20grain%2C%20consistent%20drama%20style%2C%20high%20detail%2C%20no%20text&width=400&height=400&seq=cast-07-3&orientation=squarish',
        role: '办公室开心果，也是最靠谱的神助攻。',
        intro: '承包了全剧一半的笑点和一半的助攻。',
      },
      {
        id: 'sc-4',
        name: '黎昭',
        actor: '黎昭',
        avatar:
          'https://readdy.ai/api/search-image?query=cinematic%20character%20portrait%20of%20an%20elegant%20young%20career%20woman%20with%20long%20hair%2C%20soft%20studio%20lighting%2C%20blush%20pink%20background%2C%20subtle%20film%20grain%2C%20consistent%20drama%20style%2C%20high%20detail%2C%20no%20text&width=400&height=400&seq=cast-07-4&orientation=squarish',
        role: '能力出众的竞争对手，敢爱敢恨。',
        intro: '她不是反派，只是同样勇敢地喜欢着一个人。',
      },
    ],
  },
  {
    id: 'brocade-moon',
    title: '锦月如歌',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20period%20romance%20key%20art%20of%20an%20elegant%20woman%20in%20silk%20hanfu%20under%20a%20full%20moon%2C%20warm%20romantic%20lighting%2C%20rich%20film%20color%20grading%2C%20subtle%20film%20grain%2C%20elegant%20editorial%20poster%20composition%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=cover-08&orientation=portrait',
    banner:
      'https://readdy.ai/api/search-image?query=cinematic%20wide%20key%20art%20of%20an%20ancient%20chinese%20palace%20garden%20glowing%20under%20moonlight%2C%20romantic%20atmospheric%20lighting%2C%20rich%20film%20color%20grading%2C%20subtle%20film%20grain%2C%20epic%20editorial%20composition%2C%20high%20detail%2C%20no%20text&width=1600&height=900&seq=banner-08&orientation=landscape',
    synopsis:
      '将门之女沈月昭被赐婚给质子皇子，两人从相看两厌到并肩破局。当夺嫡风暴席卷而来，他们才明白，真正想要守护的，从来不是那把椅子。',
    genres: ['古装剧', '言情剧'],
    year: 2024,
    decade: '2020年代',
    region: '中国大陆',
    rating: 7.7,
    heat: 76,
    updateTime: '2026-09-25',
    status: '全32集',
    episodeCount: 32,
    director: '云舒白',
    actors: ['谢景彻', '沈月昭', '萧沐辰', '温如絮'],
    tags: ['先婚后爱', '古风美学', '双强'],
    featured: false,
    cast: [
      {
        id: 'bm-1',
        name: '谢景彻',
        actor: '谢景彻',
        avatar:
          'https://readdy.ai/api/search-image?query=cinematic%20character%20portrait%20of%20a%20handsome%20ancient%20chinese%20prince%20in%20embroidered%20robes%2C%20warm%20studio%20lighting%2C%20dusty%20rose%20background%2C%20subtle%20film%20grain%2C%20consistent%20drama%20style%2C%20high%20detail%2C%20no%20text&width=400&height=400&seq=cast-08-1&orientation=squarish',
        role: '质子皇子，表面闲散，实则步步为营。',
        intro: '隐忍与深情兼具，是全剧最具反差感的角色。',
      },
      {
        id: 'bm-2',
        name: '沈月昭',
        actor: '沈月昭',
        avatar:
          'https://readdy.ai/api/search-image?query=cinematic%20character%20portrait%20of%20a%20brave%20ancient%20chinese%20general%20daughter%20in%20light%20armor%2C%20warm%20studio%20lighting%2C%20dusty%20rose%20background%2C%20subtle%20film%20grain%2C%20consistent%20drama%20style%2C%20high%20detail%2C%20no%20text&width=400&height=400&seq=cast-08-2&orientation=squarish',
        role: '将门之女，能文能武，不屑于闺阁规矩。',
        intro: '她的飒爽与柔软，构成了最鲜明的人物弧光。',
      },
      {
        id: 'bm-3',
        name: '萧沐辰',
        actor: '萧沐辰',
        avatar:
          'https://readdy.ai/api/search-image?query=cinematic%20character%20portrait%20of%20a%20cold%20ancient%20chinese%20crown%20prince%20in%20dark%20robes%2C%20warm%20studio%20lighting%2C%20dusty%20rose%20background%2C%20subtle%20film%20grain%2C%20consistent%20drama%20style%2C%20high%20detail%2C%20no%20text&width=400&height=400&seq=cast-08-3&orientation=squarish',
        role: '当朝太子，城府极深，是谢景彻最主要的对手。',
        intro: '他的野心，让整座皇城都成了棋局。',
      },
      {
        id: 'bm-4',
        name: '温如絮',
        actor: '温如絮',
        avatar:
          'https://readdy.ai/api/search-image?query=cinematic%20character%20portrait%20of%20a%20gentle%20ancient%20chinese%20lady%20in%20flowing%20silk%2C%20warm%20studio%20lighting%2C%20dusty%20rose%20background%2C%20subtle%20film%20grain%2C%20consistent%20drama%20style%2C%20high%20detail%2C%20no%20text&width=400&height=400&seq=cast-08-4&orientation=squarish',
        role: '沈月昭的挚友，温柔细腻，藏着不为人知的心事。',
        intro: '她用最安静的方式，守护着在意的人。',
      },
    ],
  },
  {
    id: 'neon-fox',
    title: '霓虹狐影',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20neo%20noir%20drama%20key%20art%20of%20a%20figure%20in%20a%20glowing%20neon%20cyberpunk%20street%2C%20dramatic%20neon%20lighting%2C%20rich%20film%20color%20grading%2C%20subtle%20film%20grain%2C%20elegant%20editorial%20poster%20composition%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=cover-09&orientation=portrait',
    banner:
      'https://readdy.ai/api/search-image?query=cinematic%20wide%20key%20art%20of%20a%20neon%20lit%20city%20street%20in%20the%20rain%20at%20night%2C%20dramatic%20neon%20lighting%2C%20rich%20film%20color%20grading%2C%20subtle%20film%20grain%2C%20epic%20editorial%20composition%2C%20high%20detail%2C%20no%20text&width=1600&height=900&seq=banner-09&orientation=landscape',
    synopsis:
      '一次伪造身份的交易，让普通程序员误入信息黑市。为了自证清白，他不得不与神秘黑客联手，在被算法操控的城市里，找回属于自己的真实身份。',
    genres: ['悬疑剧', '科幻剧'],
    year: 2025,
    decade: '2020年代',
    region: '中国大陆',
    rating: 7.6,
    heat: 74,
    updateTime: '2026-09-20',
    status: '更新至16集',
    episodeCount: 24,
    director: '骆川',
    actors: ['许砚深', '纪云舒', '柯屿', '安之'],
    tags: ['赛博美学', '网络犯罪', '节奏凌厉'],
    featured: false,
    cast: [
      {
        id: 'nf-1',
        name: '许砚深',
        actor: '许砚深',
        avatar:
          'https://readdy.ai/api/search-image?query=cinematic%20character%20portrait%20of%20a%20nervous%20young%20male%20programmer%20with%20glasses%2C%20neon%20studio%20lighting%2C%20dark%20magenta%20background%2C%20subtle%20film%20grain%2C%20consistent%20drama%20style%2C%20high%20detail%2C%20no%20text&width=400&height=400&seq=cast-09-1&orientation=squarish',
        role: '普通程序员，被迫卷入信息黑市的漩涡。',
        intro: '从怯懦到果断，他的转变撑起了整部剧的成长线。',
      },
      {
        id: 'nf-2',
        name: '纪云舒',
        actor: '纪云舒',
        avatar:
          'https://readdy.ai/api/search-image?query=cinematic%20character%20portrait%20of%20a%20cool%20female%20hacker%20with%20short%20hair%2C%20neon%20studio%20lighting%2C%20dark%20magenta%20background%2C%20subtle%20film%20grain%2C%20consistent%20drama%20style%2C%20high%20detail%2C%20no%20text&width=400&height=400&seq=cast-09-2&orientation=squarish',
        role: '神秘黑客，行踪不定，立场成谜。',
        intro: '她既是引路人，也是最危险的变数。',
      },
      {
        id: 'nf-3',
        name: '柯屿',
        actor: '柯屿',
        avatar:
          'https://readdy.ai/api/search-image?query=cinematic%20character%20portrait%20of%20a%20sharp%20male%20security%20analyst%20in%20a%20dark%20jacket%2C%20neon%20studio%20lighting%2C%20dark%20magenta%20background%2C%20subtle%20film%20grain%2C%20consistent%20drama%20style%2C%20high%20detail%2C%20no%20text&width=400&height=400&seq=cast-09-3&orientation=squarish',
        role: '安全公司分析师，正邪难辨的关键人物。',
        intro: '他的每一次出手，都让局势更加扑朔迷离。',
      },
      {
        id: 'nf-4',
        name: '安之',
        actor: '安之',
        avatar:
          'https://readdy.ai/api/search-image?query=cinematic%20character%20portrait%20of%20a%20quiet%20female%20data%20journalist%2C%20neon%20studio%20lighting%2C%20dark%20magenta%20background%2C%20subtle%20film%20grain%2C%20consistent%20drama%20style%2C%20high%20detail%2C%20no%20text&width=400&height=400&seq=cast-09-4&orientation=squarish',
        role: '数据记者，专门揭露平台算法的黑箱。',
        intro: '她掌握的资料，足以动摇整个信息帝国。',
      },
    ],
  },
  {
    id: 'warm-fireworks',
    title: '烟火人间',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20family%20drama%20key%20art%20of%20a%20warm%20family%20dinner%20table%20with%20golden%20evening%20light%2C%20warm%20cozy%20lighting%2C%20rich%20film%20color%20grading%2C%20subtle%20film%20grain%2C%20elegant%20editorial%20poster%20composition%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=cover-10&orientation=portrait',
    banner:
      'https://readdy.ai/api/search-image?query=cinematic%20wide%20key%20art%20of%20a%20cozy%20old%20neighborhood%20at%20dusk%20with%20warm%20window%20lights%2C%20warm%20atmospheric%20lighting%2C%20rich%20film%20color%20grading%2C%20subtle%20film%20grain%2C%20epic%20editorial%20composition%2C%20high%20detail%2C%20no%20text&width=1600&height=900&seq=banner-10&orientation=landscape',
    synopsis:
      '老街一家开了三十年的面馆，见证着三代人的聚散离合。父亲固执，女儿叛逆，孙女机灵，一碗面里藏着说不出口的牵挂与原谅。',
    genres: ['家庭剧', '现代剧'],
    year: 2024,
    decade: '2020年代',
    region: '中国大陆',
    rating: 8.1,
    heat: 79,
    updateTime: '2026-09-18',
    status: '全26集',
    episodeCount: 26,
    director: '吴长庚',
    actors: ['吴长庚', '周淑仪', '郑好', '何以安'],
    tags: ['温情', '烟火气', '催泪'],
    featured: false,
    cast: [
      {
        id: 'wf-1',
        name: '吴长庚',
        actor: '吴长庚',
        avatar:
          'https://readdy.ai/api/search-image?query=cinematic%20character%20portrait%20of%20a%20kind%20older%20male%20noodle%20shop%20owner%20with%20an%20apron%2C%20warm%20studio%20lighting%2C%20cream%20background%2C%20subtle%20film%20grain%2C%20consistent%20drama%20style%2C%20high%20detail%2C%20no%20text%2C%20no%20text&width=400&height=400&seq=cast-10-1&orientation=squarish',
        role: '面馆老板，固执又不善表达的父亲。',
        intro: '他所有的爱，都藏在每天清晨的那锅汤里。',
      },
      {
        id: 'wf-2',
        name: '周淑仪',
        actor: '周淑仪',
        avatar:
          'https://readdy.ai/api/search-image?query=cinematic%20character%20portrait%20of%20a%20warm%20middle%20aged%20mother%20with%20a%20gentle%20smile%2C%20warm%20studio%20lighting%2C%20cream%20background%2C%20subtle%20film%20grain%2C%20consistent%20drama%20style%2C%20high%20detail%2C%20no%20text&width=400&height=400&seq=cast-10-2&orientation=squarish',
        role: '母亲，是家里最柔软也最坚韧的那个人。',
        intro: '她用耐心缝合着这个家所有的裂痕。',
      },
      {
        id: 'wf-3',
        name: '郑好',
        actor: '郑好',
        avatar:
          'https://readdy.ai/api/search-image?query=cinematic%20character%20portrait%20of%20a%20stubborn%20young%20female%20designer%20with%20a%20ponytail%2C%20warm%20studio%20lighting%2C%20cream%20background%2C%20subtle%20film%20grain%2C%20consistent%20drama%20style%2C%20high%20detail%2C%20no%20text&width=400&height=400&seq=cast-10-3&orientation=squarish',
        role: '女儿，一心想离开老街去大城市闯荡。',
        intro: '她的倔强之下，藏着对家最深的依赖。',
      },
      {
        id: 'wf-4',
        name: '何以安',
        actor: '何以安',
        avatar:
          'https://readdy.ai/api/search-image?query=cinematic%20character%20portrait%20of%20a%20lively%20young%20girl%20with%20braids%2C%20warm%20studio%20lighting%2C%20cream%20background%2C%20subtle%20film%20grain%2C%20consistent%20drama%20style%2C%20high%20detail%2C%20no%20text&width=400&height=400&seq=cast-10-4&orientation=squarish',
        role: '孙女，机灵可爱，是两代人之间的黏合剂。',
        intro: '她的童言无忌，总能戳中大人不敢说的心事。',
      },
    ],
  },
  {
    id: 'ten-years',
    title: '我们的十年',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20youth%20drama%20key%20art%20of%20a%20group%20of%20friends%20in%20golden%20hour%20sunlight%2C%20nostalgic%20warm%20lighting%2C%20rich%20film%20color%20grading%2C%20subtle%20film%20grain%2C%20elegant%20editorial%20poster%20composition%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=cover-11&orientation=portrait',
    banner:
      'https://readdy.ai/api/search-image?query=cinematic%20wide%20key%20art%20of%20a%20sunlit%20campus%20playground%20in%20golden%20hour%2C%20nostalgic%20warm%20lighting%2C%20rich%20film%20color%20grading%2C%20subtle%20film%20grain%2C%20epic%20editorial%20composition%2C%20high%20detail%2C%20no%20text&width=1600&height=900&seq=banner-11&orientation=landscape',
    synopsis:
      '大学宿舍的四个人，毕业后各奔东西。十年后再聚首，才发现当年赌气说下的狠话，早已被时间悄悄原谅。关于青春，也关于和解。',
    genres: ['现代剧', '言情剧'],
    year: 2023,
    decade: '2020年代',
    region: '中国大陆',
    rating: 7.5,
    heat: 71,
    updateTime: '2026-09-12',
    status: '全24集',
    episodeCount: 24,
    director: '何洛川',
    actors: ['唐叙', '夏之岸', '阮清野', '柏川'],
    tags: ['青春', '友谊', '回忆杀'],
    featured: false,
    cast: [
      {
        id: 'ty-1',
        name: '唐叙',
        actor: '唐叙',
        avatar:
          'https://readdy.ai/api/search-image?query=cinematic%20character%20portrait%20of%20a%20reliable%20young%20male%20friend%20in%20a%20knit%20sweater%2C%20warm%20studio%20lighting%2C%20soft%20sage%20background%2C%20subtle%20film%20grain%2C%20consistent%20drama%20style%2C%20high%20detail%2C%20no%20text&width=400&height=400&seq=cast-11-1&orientation=squarish',
        role: '宿舍里的老大哥，永远把朋友放在第一位。',
        intro: '他是所有人疲惫时可以依靠的那堵墙。',
      },
      {
        id: 'ty-2',
        name: '夏之岸',
        actor: '夏之岸',
        avatar:
          'https://readdy.ai/api/search-image?query=cinematic%20character%20portrait%20of%20a%20quiet%20young%20woman%20with%20a%20camera%2C%20warm%20studio%20lighting%2C%20soft%20sage%20background%2C%20subtle%20film%20grain%2C%20consistent%20drama%20style%2C%20high%20detail%2C%20no%20text&width=400&height=400&seq=cast-11-2&orientation=squarish',
        role: '文艺女青年，用镜头记录着所有人的青春。',
        intro: '十年后的重逢，从她的一卷旧底片开始。',
      },
      {
        id: 'ty-3',
        name: '阮清野',
        actor: '阮清野',
        avatar:
          'https://readdy.ai/api/search-image?query=cinematic%20character%20portrait%20of%20an%20ambitious%20young%20man%20in%20a%20suit%2C%20warm%20studio%20lighting%2C%20soft%20sage%20background%2C%20subtle%20film%20grain%2C%20consistent%20drama%20style%2C%20high%20detail%2C%20no%20text&width=400&height=400&seq=cast-11-3&orientation=squarish',
        role: '当年最要强的那个，如今活得最拧巴。',
        intro: '他的转变，是这部剧最戳心的一笔。',
      },
      {
        id: 'ty-4',
        name: '柏川',
        actor: '柏川',
        avatar:
          'https://readdy.ai/api/search-image?query=cinematic%20character%20portrait%20of%20a%20cheerful%20young%20man%20with%20a%20guitar%2C%20warm%20studio%20lighting%2C%20soft%20sage%20background%2C%20subtle%20film%20grain%2C%20consistent%20drama%20style%2C%20high%20detail%2C%20no%20text&width=400&height=400&seq=cast-11-4&orientation=squarish',
        role: '乐队梦青年，把聚会变成了十年之约。',
        intro: '他用一首歌唱哭了屏幕前的每一个人。',
      },
    ],
  },
  {
    id: 'dragon-city',
    title: '龙城往事',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20period%20drama%20key%20art%20of%20a%20vintage%20chinese%20old%20town%20street%20in%20the%201980s%2C%20nostalgic%20warm%20lighting%2C%20rich%20film%20color%20grading%2C%20subtle%20film%20grain%2C%20elegant%20editorial%20poster%20composition%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=cover-12&orientation=portrait',
    banner:
      'https://readdy.ai/api/search-image?query=cinematic%20wide%20key%20art%20of%20a%20vintage%20chinese%20factory%20district%20at%20sunset%20in%20the%201980s%2C%20nostalgic%20warm%20lighting%2C%20rich%20film%20color%20grading%2C%20subtle%20film%20grain%2C%20epic%20editorial%20composition%2C%20high%20detail%2C%20no%20text&width=1600&height=900&seq=banner-12&orientation=landscape',
    synopsis:
      '八十年代的龙城，一群年轻人在时代的浪潮里选择各自的活法。有人下海经商，有人守着工厂，有人错过了最好的人。多年以后回望，才懂得时代赋予的答案。',
    genres: ['历史剧', '家庭剧'],
    year: 2022,
    decade: '2020年代',
    region: '中国大陆',
    rating: 7.9,
    heat: 70,
    updateTime: '2026-09-05',
    status: '全30集',
    episodeCount: 30,
    director: '康致远',
    actors: ['程建国', '林秀兰', '赵卫东', '何小满'],
    tags: ['年代感', '时代群像', '耐人寻味'],
    featured: false,
    cast: [
      {
        id: 'dc-1',
        name: '程建国',
        actor: '程建国',
        avatar:
          'https://readdy.ai/api/search-image?query=cinematic%20character%20portrait%20of%20a%20determined%20young%20man%20in%20retro%201980s%20clothing%2C%20warm%20studio%20lighting%2C%20retro%20sepia%20background%2C%20subtle%20film%20grain%2C%20consistent%20drama%20style%2C%20high%20detail%2C%20no%20text&width=400&height=400&seq=cast-12-1&orientation=squarish',
        role: '工厂技术骨干，第一个敢于辞职下海的人。',
        intro: '他的选择，代表了一个时代年轻人的勇气。',
      },
      {
        id: 'dc-2',
        name: '林秀兰',
        actor: '林秀兰',
        avatar:
          'https://readdy.ai/api/search-image?query=cinematic%20character%20portrait%20of%20a%20kind%20young%20woman%20in%20retro%201980s%20dress%2C%20warm%20studio%20lighting%2C%20retro%20sepia%20background%2C%20subtle%20film%20grain%2C%20consistent%20drama%20style%2C%20high%20detail%2C%20no%20text&width=400&height=400&seq=cast-12-2&orientation=squarish',
        role: '纺织厂女工，温柔而坚韧，是龙城最美的记忆。',
        intro: '她的等待与成全，让整部剧多了一层温柔底色。',
      },
      {
        id: 'dc-3',
        name: '赵卫东',
        actor: '赵卫东',
        avatar:
          'https://readdy.ai/api/search-image?query=cinematic%20character%20portrait%20of%20a%20loyal%20young%20factory%20worker%20in%20a%20work%20jacket%2C%20warm%20studio%20lighting%2C%20retro%20sepia%20background%2C%20subtle%20film%20grain%2C%20consistent%20drama%20style%2C%20high%20detail%2C%20no%20text&width=400&height=400&seq=cast-12-3&orientation=squarish',
        role: '重情重义的车间班长，守着老一辈的规矩。',
        intro: '他的坚守，让"匠人"两个字有了分量。',
      },
      {
        id: 'dc-4',
        name: '何小满',
        actor: '何小满',
        avatar:
          'https://readdy.ai/api/search-image?query=cinematic%20character%20portrait%20of%20a%20bright%20young%20woman%20with%20a%20notebook%20in%20retro%20clothing%2C%20warm%20studio%20lighting%2C%20retro%20sepia%20background%2C%20subtle%20film%20grain%2C%20consistent%20drama%20style%2C%20high%20detail%2C%20no%20text&width=400&height=400&seq=cast-12-4&orientation=squarish',
        role: '恢复高考后的第一批大学生，怀揣着改变世界的理想。',
        intro: '她带回了龙城从未有过的新鲜想法。',
      },
    ],
  },
];